var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.302 21.6149C11.5234 21.744 11.6341 21.8086 11.7903 21.8421C11.9116 21.8681 12.0884 21.8681 12.2097 21.8421C12.3659 21.8086 12.4766 21.744 12.698 21.6149C14.646 20.4784 20 16.9084 20 12V8.20001C20 7.12611 20 6.58916 19.8345 6.20801C19.6662 5.82061 19.4986 5.61452 19.1536 5.37091C18.8141 5.13123 18.1486 4.99283 16.8177 4.71603C15.3508 4.41094 14.2243 3.86004 13.1944 3.06333C12.7005 2.68127 12.4536 2.49025 12.2603 2.43814C12.0564 2.38317 11.9436 2.38317 11.7397 2.43814C11.5464 2.49025 11.2995 2.68127 10.8056 3.06333C9.77572 3.86004 8.6492 4.41094 7.1823 4.71603C5.85137 4.99283 5.18591 5.13123 4.84645 5.37091C4.50142 5.61452 4.33379 5.82061 4.16554 6.20801C4 6.58916 4 7.12611 4 8.2V12C4 16.9084 9.35396 20.4784 11.302 21.6149Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield02);
export default __webpack_public_path__ + "static/media/shield-02.1f9b0bc9f5f1eae85c703a2c89f3a07d.svg";
export { ForwardRef as ReactComponent };